import React, { useState } from "react";
import PasswordRecoveryRequests from "./PasswordRecoveryRequests";
import PendingSignups from "./PendingSignups";
import ProfileChangeRequests from "./ProfileChangeRequests";
import RegisteredAccountDirectory from "./RegisteredAccountDirectory";

export default function AccessAndAccounts({ showAccounts = false, accountsApi, actorId }) {
  const tabs = [
    { id: "signups", label: "Signup requests" },
    { id: "recovery", label: "Password recovery" },
    { id: "profile-changes", label: "Profile changes" },
    ...(showAccounts ? [{ id: "accounts", label: "Accounts" }] : []),
  ];
  const [selected, setSelected] = useState("signups");
  const activeTab = tabs.some((tab) => tab.id === selected) ? selected : tabs[0].id;

  const handleTabKeyDown = (event) => {
    const currentIndex = tabs.findIndex((tab) => tab.id === activeTab);
    let nextIndex = currentIndex;
    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % tabs.length;
    else if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    else if (event.key === "Home") nextIndex = 0;
    else if (event.key === "End") nextIndex = tabs.length - 1;
    else return;
    event.preventDefault();
    const nextTab = tabs[nextIndex].id;
    setSelected(nextTab);
    document.getElementById(`iam-tab-${nextTab}`)?.focus();
  };

  return (
    <section className="iam-access-section" aria-label="Access and accounts">
      <div className="iam-access-heading">
        <div className="studio-eyebrow">ACCESS &amp; ACCOUNTS</div>
        <h2>Membership, recovery, and registered identities</h2>
      </div>
      <div className="iam-access-tabs" role="tablist" aria-label="Access and accounts sections">
        {tabs.map((tab) => (
          <button key={tab.id} id={`iam-tab-${tab.id}`} type="button" role="tab"
            aria-selected={activeTab === tab.id} aria-controls={`iam-panel-${tab.id}`}
            tabIndex={activeTab === tab.id ? 0 : -1} className="studio-btn-ghost"
            onKeyDown={handleTabKeyDown}
            onClick={() => setSelected(tab.id)}>
            {tab.label}
          </button>
        ))}
      </div>
      <div id={`iam-panel-${activeTab}`} role="tabpanel" aria-labelledby={`iam-tab-${activeTab}`}>
        {activeTab === "signups" && <PendingSignups />}
        {activeTab === "recovery" && <PasswordRecoveryRequests />}
        {activeTab === "profile-changes" && <ProfileChangeRequests />}
        {activeTab === "accounts" && showAccounts && (
          <RegisteredAccountDirectory api={accountsApi} actorId={actorId} />
        )}
      </div>
    </section>
  );
}
